export default "__VITE_ASSET__D0dsIb14__"